// src/subjects.ts
var SUBJECTS = {
  "Biologia": "biologia",
  "Chemia": "chemia",
  "Edukacja dla bezpiecze\u0144stwa": "edukacja-dla-bezpieczenstwa",
  "Edukacja obywatelska": "edukacja-obywatelska",
  "Edukacja zdrowotna": "edukacja-zdrowotna",
  "Edukacja zdrowotna \u2013 zdrowie seksualne": "edukacja-zdrowotna-zdrowie-seksualne",
  "Etyka": "etyka",
  "Fizyka": "fizyka",
  "Geografia": "geografia",
  "Historia": "historia",
  "Informatyka": "informatyka",
  "J\u0119zyk mniejszo\u015Bci narodowej lub etnicznej": "jezyk-mniejszosci-narodowej-lub-etnicznej",
  "J\u0119zyk obcy nowo\u017Cytny": "jezyk-obcy-nowozytny",
  "J\u0119zyk polski": "jezyk-polski",
  "J\u0119zyk regionalny - kaszubski": "jezyk-regionalny--jezyk-kaszubski",
  "J\u0119zyk \u0142aci\u0144ski": "jezyk-lacinski",
  "Kszta\u0142cenie obronne": "ksztalcenie-obronne",
  "Matematyka": "matematyka",
  "Muzyka": "muzyka",
  "Plastyka": "plastyka",
  "Przyroda": "przyroda",
  "Technika": "technika",
  "Wiedza o spo\u0142ecze\u0144stwie": "wiedza-o-spoleczenstwie",
  "Wychowanie do \u017Cycia w rodzinie": "wychowanie-do-zycia-w-rodzinie",
  "Wychowanie fizyczne": "wychowanie-fizyczne",
  "Inne": "inne"
};
var getAllSubjects = () => Object.values(SUBJECTS);
var SUBJECT_DESCRIPTIONS = {
  "biologia": "budowa, fizjologia i r\xF3\u017Cnorodno\u015B\u0107 organizm\xF3w \u017Cywych \u2014 anatomia cz\u0142owieka (w tym budowa KA\u017BDEGO uk\u0142adu cia\u0142a, tak\u017Ce rozrodczego), kom\xF3rka, genetyka, ekologia (jako przedmiot od klasy 5 SP wzwy\u017C). Budowa/anatomia = biologia, nawet gdy temat dotyczy zdrowia.",
  "chemia": "budowa materii, pierwiastki i zwi\u0105zki, reakcje i przemiany chemiczne, roztwory.",
  "edukacja-dla-bezpieczenstwa": 'pierwsza pomoc, reagowanie w sytuacjach zagro\u017Cenia i wypadkach, zasady bezpiecze\u0144stwa \u2014 g\u0142\xF3wnie szko\u0142a podstawowa (kl. 8). W szkole ponadpodstawowej rol\u0119 t\u0119 przejmuje nowszy przedmiot "ksztalcenie-obronne".',
  "edukacja-obywatelska": 'ustr\xF3j pa\u0144stwa, prawa i obowi\u0105zki obywatela, instytucje, wybory, aktywno\u015B\u0107 obywatelska i media. NOWY przedmiot (Reforma26) \u2014 w\u0142a\u015Bciwy w szkole ponadpodstawowej ORAZ w klasach SP ju\u017C obj\u0119tych reform\u0105; dla pozosta\u0142ych klas SP t\u0119 sam\u0105 tematyk\u0119 realizuje "wiedza-o-spoleczenstwie" (rozstrzyga regu\u0142a klasowa/etapowa w tre\u015Bci zadania powy\u017Cej).',
  "edukacja-zdrowotna": 'zdrowie fizyczne i psychiczne, od\u017Cywianie, sen, dojrzewanie (bez w\u0105tku stricte seksualnego), relacje i \u017Cycie rodzinne, profilaktyka uzale\u017Cnie\u0144. NOWY przedmiot \u2014 ZAST\u0118PUJE zniesione "wychowanie-do-zycia-w-rodzinie" (preferuj ten, nie Wd\u017B).',
  "edukacja-zdrowotna-zdrowie-seksualne": "osobny przedmiot dla temat\xF3w stricte seksualnych: p\u0142odno\u015B\u0107, antykoncepcja, inicjacja seksualna, choroby przenoszone drog\u0105 p\u0142ciow\u0105, zgoda i granice w relacjach intymnych.",
  "etyka": "refleksja moralna \u2014 dobro i z\u0142o, warto\u015Bci, sumienie, dylematy etyczne i bioetyczne.",
  "fizyka": "zjawiska i prawa przyrody nieo\u017Cywionej \u2014 mechanika, elektryczno\u015B\u0107, optyka, energia, budowa materii w uj\u0119ciu fizycznym.",
  "geografia": "Ziemia i jej powierzchnia, klimat, geologia, \u015Brodowisko, ludno\u015B\u0107 i gospodarka (jako przedmiot od klasy 5 SP wzwy\u017C).",
  "historia": "dzieje \u2014 wydarzenia, postaci, procesy i \u017Ar\xF3d\u0142a z przesz\u0142o\u015Bci, w tym dokumenty i ustroje w uj\u0119ciu historycznym.",
  "informatyka": "programowanie, algorytmy, technologie cyfrowe, praca z danymi i arkuszami, sieci i cyberbezpiecze\u0144stwo.",
  "jezyk-mniejszosci-narodowej-lub-etnicznej": "nauka j\u0119zyka i kultury mniejszo\u015Bci narodowej lub etnicznej (np. niemieckiej, litewskiej, bia\u0142oruskiej, \u0142emkowskiej) \u2014 przedmiot dla uczni\xF3w danej mniejszo\u015Bci.",
  "jezyk-obcy-nowozytny": "nauka wsp\xF3\u0142czesnego j\u0119zyka obcego (angielski, niemiecki, francuski, hiszpa\u0144ski, rosyjski itd.) \u2014 gramatyka, s\u0142ownictwo, komunikacja, realioznawstwo kraj\xF3w danego j\u0119zyka.",
  "jezyk-polski": "j\u0119zyk polski \u2014 gramatyka, ortografia, lektury i literatura, analiza tekst\xF3w, formy wypowiedzi (rozprawka, podanie).",
  "jezyk-regionalny--jezyk-kaszubski": "nauka j\u0119zyka kaszubskiego oraz kultury i tradycji Kaszub \u2014 j\u0119zyk regionalny, odr\u0119bny od j\u0119zyk\xF3w mniejszo\u015Bci narodowych.",
  "jezyk-lacinski": "nauka \u0142aciny \u2014 gramatyka, t\u0142umaczenie tekst\xF3w, sentencje oraz kultura antyczna poznawana przez j\u0119zyk.",
  "ksztalcenie-obronne": 'NOWY przedmiot (Reforma26) w szkole ponadpodstawowej \u2014 obronno\u015B\u0107 pa\u0144stwa, Si\u0142y Zbrojne RP, terenoznawstwo, obrona cywilna i zarz\u0105dzanie kryzysowe, pierwsza pomoc w warunkach zagro\u017Cenia. Na tym etapie PREFEROWANY nad "edukacja-dla-bezpieczenstwa".',
  "matematyka": "liczby i dzia\u0142ania, u\u0142amki, procenty, geometria, funkcje, rachunek prawdopodobie\u0144stwa \u2014 rozumowanie i obliczenia matematyczne.",
  "muzyka": "teoria i historia muzyki, notacja, instrumenty, \u015Bpiew oraz s\u0142uchanie i tworzenie muzyki (w tym sylwetki kompozytor\xF3w).",
  "plastyka": "sztuki wizualne \u2014 rysunek, malarstwo, barwa i kompozycja, a tak\u017Ce historia sztuki i architektury.",
  "przyroda": "zintegrowany przedmiot przyrodniczy realizowany TYLKO w klasie 4 SP \u2014 og\xF3lne poznawanie przyrody i najbli\u017Cszego otoczenia; w klasach 5+ zast\u0119puj\u0105 go biologia, geografia, fizyka i chemia.",
  "technika": "praktyczne umiej\u0119tno\u015Bci techniczne \u2014 rysunek techniczny, materia\u0142y i narz\u0119dzia, majsterkowanie, bezpiecze\u0144stwo pracy oraz wychowanie komunikacyjne (karta rowerowa).",
  "wiedza-o-spoleczenstwie": 'spo\u0142ecze\u0144stwo, pa\u0144stwo, prawo i instytucje \u2014 w szkole podstawowej dla rocznik\xF3w jeszcze na starej podstawie. Tam gdzie obowi\u0105zuje Reforma26 zast\u0119puje go "edukacja-obywatelska".',
  "wychowanie-do-zycia-w-rodzinie": 'PRZEDMIOT ZNIESIONY \u2014 NIE wybieraj go. Jego tematyk\u0119 przej\u0119\u0142a "edukacja-zdrowotna" (a w\u0105tki stricte seksualne \u2014 "edukacja-zdrowotna-zdrowie-seksualne").',
  "wychowanie-fizyczne": "aktywno\u015B\u0107 fizyczna i ruchowa \u2014 sport, gry zespo\u0142owe, lekkoatletyka, rozgrzewka, sprawno\u015B\u0107 i kondycja.",
  "inne": "u\u017Cyj TYLKO gdy temat nie nale\u017Cy do \u017Cadnego przedmiotu szkolnego z listy \u2014 np. hobby, umiej\u0119tno\u015Bci \u017Cycia codziennego, tematy zawodowe lub dla doros\u0142ych spoza podstawy programowej."
};
var SUBJECT_DESCRIPTIONS_TIMELESS = {
  ...SUBJECT_DESCRIPTIONS,
  "biologia": "budowa, fizjologia i r\xF3\u017Cnorodno\u015B\u0107 organizm\xF3w \u017Cywych \u2014 anatomia cz\u0142owieka (w tym budowa KA\u017BDEGO uk\u0142adu cia\u0142a, tak\u017Ce rozrodczego), kom\xF3rka, genetyka, ekologia. Budowa/anatomia = biologia, nawet gdy temat dotyczy zdrowia.",
  "geografia": "Ziemia i jej powierzchnia, klimat, geologia, \u015Brodowisko, ludno\u015B\u0107 i gospodarka.",
  "przyroda": "zintegrowany przedmiot przyrodniczy m\u0142odszych klas szko\u0142y podstawowej \u2014 \u0142\u0105czy elementy biologii, geografii, fizyki i chemii; og\xF3lne poznawanie przyrody i najbli\u017Cszego otoczenia. W klasach, w kt\xF3rych obowi\u0105zuje (patrz mapa), wybieraj go zamiast przedmiot\xF3w szczeg\xF3\u0142owych.",
  "edukacja-dla-bezpieczenstwa": 'pierwsza pomoc, reagowanie w sytuacjach zagro\u017Cenia i wypadkach, zasady bezpiecze\u0144stwa. W nowej podstawie (Reforma26) jego rol\u0119 przejmuje "ksztalcenie-obronne" \u2014 gdy mapa dopuszcza oba, preferuj nowszy.',
  "ksztalcenie-obronne": 'NOWY przedmiot (Reforma26) \u2014 obronno\u015B\u0107 pa\u0144stwa, Si\u0142y Zbrojne RP, terenoznawstwo, obrona cywilna i zarz\u0105dzanie kryzysowe, pierwsza pomoc w warunkach zagro\u017Cenia. PREFEROWANY nad "edukacja-dla-bezpieczenstwa" tam, gdzie obowi\u0105zuje nowa podstawa.',
  "edukacja-obywatelska": 'ustr\xF3j pa\u0144stwa, prawa i obowi\u0105zki obywatela, instytucje, wybory, aktywno\u015B\u0107 obywatelska i media. NOWY przedmiot (Reforma26) \u2014 t\u0119 sam\u0105 tematyk\u0119 w rocznikach na starej podstawie realizuje "wiedza-o-spoleczenstwie" (rozstrzyga regu\u0142a klasowa w tre\u015Bci zadania i mapa).',
  "wychowanie-do-zycia-w-rodzinie": 'relacje, rodzina, dojrzewanie i wychowanie do \u017Cycia rodzinnego \u2014 przedmiot starej podstawy; w nowej podstawie (Reforma26) jego tematyk\u0119 przejmuje "edukacja-zdrowotna" (a w\u0105tki stricte seksualne "edukacja-zdrowotna-zdrowie-seksualne") \u2014 gdy mapa dopuszcza oba, preferuj nowszy.'
};
var getSubjectsWithDescriptions = (subjects, descriptions = SUBJECT_DESCRIPTIONS) => subjects.map((s) => `- ${s}: ${descriptions[s] ?? ""}`).join("\n");

// src/types/profile.ts
import { z } from "zod";
var acquisitionSourceSchema = z.object({
  utm_source: z.string().max(200).optional(),
  utm_medium: z.string().max(200).optional(),
  utm_campaign: z.string().max(200).optional(),
  utm_content: z.string().max(200).optional(),
  utm_term: z.string().max(200).optional(),
  fbclid: z.string().max(500).optional(),
  referrer_host: z.string().max(200).optional(),
  landing_path: z.string().max(500),
  captured_at: z.string().datetime()
}).strict();

// src/types/lesson/scenario.ts
import { z as z2 } from "zod";
var SCENARIO_DURATION_OPTIONS = [15, 30, 45, 60, 90, 120];
var INSTRUCTION_MAX_LENGTH = 500;
var instructionSchema = z2.string().trim().min(1).max(INSTRUCTION_MAX_LENGTH).refine((s) => !/[<>]/.test(s), { message: "instruction must not contain angle brackets" });
var REJECT_REASONS = ["poza-tematem", "rozdecie", "tresc-niedozwolona", "atak", "ujawnienie-promptu"];
var GenerateScenarioFormDTOSchema = z2.object({
  duration: z2.number().int().min(1).max(120),
  instruction: instructionSchema.optional()
});

// src/models/availableModels.ts
var AvailableModels = {
  "anthropic": ["claude-3-5-sonnet-latest", "claude-3-5-haiku-latest"],
  "openai": ["gpt-4o", "gpt-4o-mini", "gpt-5-mini"],
  "google": ["gemini-2.0-flash", "gemini-2.5-flash", "gemini-3-flash-preview"],
  // model id uses '/', never ':' or '?', so parseModelString splits provider/model/params cleanly
  // (e.g. "tensorx:deepseek/deepseek-v4-flash?thinking=none")
  // TensorX wystawia wylacznie datowane snapshoty — nieoznaczony alias
  // 'deepseek/deepseek-v4-flash' PRZESTAL istniec w ich katalogu i wywolanie nim konczy sie
  // bledem. Trzymamy tu dokladnie to, co zwraca GET /v1/models, i sprawdzamy przy zmianie.
  "tensorx": ["deepseek/deepseek-v4-flash-0731"],
  // Oficjalne API DeepSeeka — tańsze, szybkie do analizy bez myślenia
  "deepseek": ["deepseek-v4-flash"],
  // Nebius Token Factory (EU, Finlandia) — 5-7x szybszy od TensorX na tym samym modelu.
  // UWAGA: zmierzone 2026-08-19 okna degradacji (HTTP 503 na całej serii, tool-calle
  // zwijające się do 2-6 zamiast ~14 wywołań, luźne typowanie argumentów) — patrz
  // evals/reference/EVAL-2026-08-19T1900_nebius-vs-tensorx.md. Na razie tylko dev.
  "nebius": ["deepseek-ai/DeepSeek-V4-Flash"],
  // CoreWeave — ten sam snapshot co tensorx, ale serwowany przez CoreWeave (fp8) i osiagany
  // przez OpenRouter z przypietym providerem. Tanszy na wejsciu ($0.13 vs $0.25 /1M) i 2-4x
  // szybszy; kontekst 262k zamiast 1M, rezydencja danych nieudokumentowana. Na razie tylko dev.
  "coreweave": ["deepseek/deepseek-v4-flash-0731"]
};
var THINKING_EFFORTS = ["none", "low", "medium", "high"];
function parseModelString(modelString) {
  const [base, query] = modelString.split("?");
  const [provider, model] = base.split(":");
  const params = {};
  if (query) {
    for (const pair of query.split("&")) {
      const [key, value] = pair.split("=");
      if (key === "thinking" && value) params.thinking = value;
    }
  }
  return { provider, model, params };
}
function isValidModel(modelString) {
  const { provider, model, params } = parseModelString(modelString);
  if (!provider || !model) return false;
  if (!(provider in AvailableModels)) return false;
  if (params.thinking && !THINKING_EFFORTS.includes(params.thinking)) return false;
  const availableModels = AvailableModels[provider];
  return availableModels.includes(model);
}
function parseModel(modelString) {
  const { provider, model } = parseModelString(modelString);
  if (!provider || !model) return null;
  if (!(provider in AvailableModels)) return null;
  return [provider, model];
}
function getModelDisplayName(modelString) {
  const parsed = parseModel(modelString);
  if (!parsed) return null;
  const [provider, model] = parsed;
  return `${provider.charAt(0).toUpperCase() + provider.slice(1)} ${model}`;
}

// src/types/worksheet-items.ts
import { z as z3 } from "zod";
var GetWorksheetItemParams = z3.object({
  id: z3.string()
});
var GenerateWorksheetItemParams = z3.object({
  scenarioId: z3.string(),
  // type of the item
  type: z3.string(),
  // optional params for the item
  params: z3.record(z3.string(), z3.any()).optional(),
  // id of the item to replace
  replacePuzzleId: z3.string().optional()
});

// src/types/lesson/knowledge.ts
import { z as z4 } from "zod";
var ModifyKnowledgeFormDTOSchema = z4.object({
  instruction: instructionSchema.optional()
});

// src/types/lesson/slides.ts
var SLIDE_LAYOUTS = ["title", "section", "bullets", "question"];

// src/types/lesson/stale.ts
function isArtifactStale(lesson, kind) {
  const artifact = lesson?.[kind];
  if (!lesson || !artifact) return false;
  return artifact.scenarioId !== lesson.scenario.id;
}

// src/types/lesson/languages.ts
var languages = [
  { code: "pl", name: "Polski", polishName: "Polski" },
  { code: "pl-csb", name: "Kaszubski", polishName: "Kaszubski" },
  { code: "pl-szl", name: "\u015Al\u0105ski", polishName: "\u015Al\u0105ski" },
  { code: "uk", name: "\u0423\u043A\u0440\u0430\u0457\u043D\u0441\u044C\u043A\u0430", polishName: "Ukrai\u0144ski" },
  { code: "en", name: "English", polishName: "Angielski" },
  { code: "de", name: "Deutsch", polishName: "Niemiecki" },
  { code: "fr", name: "Fran\xE7ais", polishName: "Francuski" },
  { code: "es", name: "Espa\xF1ol", polishName: "Hiszpa\u0144ski" },
  { code: "ru", name: "\u0420\u0443\u0441\u0441\u043A\u0438\u0439", polishName: "Rosyjski" },
  { code: "be", name: "\u0411\u0435\u043B\u0430\u0440\u0443\u0441\u043A\u0430\u044F", polishName: "Bia\u0142oruski" },
  { code: "ko", name: "\uD55C\uAD6D\uC5B4", polishName: "Korea\u0144ski" },
  { code: "ja", name: "\u65E5\u672C\u8A9E", polishName: "Japo\u0144ski" }
];
function getLanguagePolishName(code) {
  return languages.find((language) => language.code === code)?.polishName ?? null;
}
var WORDSEARCH_UNSUPPORTED_LANGUAGES = /* @__PURE__ */ new Set(["ko", "ja"]);
function isWordsearchEnabled(code) {
  return !WORDSEARCH_UNSUPPORTED_LANGUAGES.has(code);
}
var NON_LATIN_SCRIPT_LANGUAGES = /* @__PURE__ */ new Set(["uk", "ru", "be", "ko", "ja"]);
function usesLatinScript(code) {
  return !NON_LATIN_SCRIPT_LANGUAGES.has(code);
}

// src/types/payment.ts
var PLANS = {
  100: 10,
  200: 20,
  500: 50
};

// src/types/lesson/const.ts
var AUTO_LABEL = "Automatycznie";
var AUTO_VALUE = "auto";
var INSUFFICIENT_CREDITS = "INSUFFICIENT_CREDITS";
var LESSON_PRICE = 10;
var LESSON_ELEMENT_POOL = 30;
var ELEMENT_POOL_EXHAUSTED = "ELEMENT_POOL_EXHAUSTED";
var STARTING_CREDITS = 50;
var INVITED_CREDITS = 50;
var INVITER_BONUS_CREDITS = 30;

// src/types/lesson/education-level.ts
var EducationLevel = {
  AUTO: 0,
  PRESCHOOL: 1,
  PRIMARY_1_3: 2,
  PRIMARY_4_6: 3,
  PRIMARY_7_8: 4,
  SECONDARY: 5,
  UNIVERSITY: 6
};
function getEducationLevelDescription(educationLevel) {
  switch (educationLevel) {
    case 0:
      return AUTO_LABEL;
    case 1:
      return "Przedszkolny";
    case 2:
      return "Klasy 1-3";
    case 3:
      return "Klasy 4-6";
    case 4:
      return "Klasy 7-8";
    case 5:
      return "Szko\u0142a \u015Brednia";
    case 6:
      return "Studia";
    default:
      return "<b\u0142\u0119dna warto\u015B\u0107>";
  }
}
function getEducationLevelDescriptionLong(educationLevel) {
  switch (educationLevel) {
    case 0:
      return AUTO_LABEL;
    case 1:
      return "Przedszkolny (3-6 lat)";
    case 2:
      return "Szko\u0142a podstawowa klasy 1-3 (7-9 lat)";
    case 3:
      return "Szko\u0142a podstawowa klasy 4-6 (10-12 lat)";
    case 4:
      return "Szko\u0142a podstawowa klasy 7-8 (13-15 lat)";
    case 5:
      return "Szko\u0142a \u015Brednia (16-19 lat)";
    case 6:
      return "Studia (20+ lat)";
    default:
      return "<b\u0142\u0119dna warto\u015B\u0107>";
  }
}
var PRIMARY_GRADE_AGE = { 1: 7, 2: 8, 3: 9, 4: 10, 5: 11, 6: 12, 7: 13, 8: 14 };
function getGradeDescription(educationLevel, grade) {
  if (grade === void 0 || !Number.isInteger(grade) || grade < 1) return void 0;
  const bands = {
    [EducationLevel.PRIMARY_1_3]: [1, 3],
    [EducationLevel.PRIMARY_4_6]: [4, 6],
    [EducationLevel.PRIMARY_7_8]: [7, 8],
    [EducationLevel.SECONDARY]: [1, 5]
  };
  const band = bands[educationLevel];
  if (!band || grade < band[0] || grade > band[1]) return void 0;
  const age = educationLevel === EducationLevel.SECONDARY ? void 0 : PRIMARY_GRADE_AGE[grade];
  return age === void 0 ? `klasa ${grade}` : `klasa ${grade} (${age} lat)`;
}
function getEducationLevelDescriptionWithoutAge(educationLevel) {
  switch (educationLevel) {
    case 0:
      return AUTO_LABEL;
    case 1:
      return "Przedszkolny";
    case 2:
      return "Szko\u0142a podstawowa klasy 1-3";
    case 3:
      return "Szko\u0142a podstawowa klasy 4-6";
    case 4:
      return "Szko\u0142a podstawowa klasy 7-8";
    case 5:
      return "Szko\u0142a \u015Brednia";
    case 6:
      return "Studia";
    default:
      return "<b\u0142\u0119dna warto\u015B\u0107>";
  }
}
function educationLevelForGrade(level, grade) {
  const bands = {
    [EducationLevel.PRIMARY_1_3]: [1, 3],
    [EducationLevel.PRIMARY_4_6]: [4, 6],
    [EducationLevel.PRIMARY_7_8]: [7, 8],
    [EducationLevel.SECONDARY]: [1, 5]
  };
  const band = bands[level];
  if (band) {
    if (grade === void 0) return true;
    return Number.isInteger(grade) && grade >= band[0] && grade <= band[1];
  } else {
    return grade === void 0;
  }
}
function primaryEducationLevelForGrade(grade) {
  if (!Number.isInteger(grade) || grade < 1 || grade > 8) {
    throw new Error(`Grade must be an integer between 1 and 8, got ${grade}`);
  }
  if (grade <= 3) {
    return EducationLevel.PRIMARY_1_3;
  } else if (grade <= 6) {
    return EducationLevel.PRIMARY_4_6;
  } else {
    return EducationLevel.PRIMARY_7_8;
  }
}

// src/types/lesson/create-lesson.ts
import { z as z5 } from "zod";

// src/curriculum-stage.ts
var CURRICULUM_STAGES = ["przedszkole", "klasy-1-3", "klasy-4-8", "ponadpodstawowa"];
var CURRICULUM_VERSIONS = ["2017-2024", "2026"];
var CURRICULUM_PAGE_WILDCARD_SUBJECT_SEGMENT = "wszystkie";
function curriculumPageSubjectToSegment(subject) {
  return subject === "*" ? CURRICULUM_PAGE_WILDCARD_SUBJECT_SEGMENT : subject;
}
function curriculumPageSubjectFromSegment(segment) {
  return segment === CURRICULUM_PAGE_WILDCARD_SUBJECT_SEGMENT ? "*" : segment;
}
function buildCurriculumPagePath(version, stage, subject) {
  const segment = curriculumPageSubjectToSegment(subject);
  return `/podstawa-programowa/${encodeURIComponent(version)}/${encodeURIComponent(stage)}/${encodeURIComponent(segment)}`;
}
function buildCurriculumApiPath(version, stage, subjectSegment) {
  return `/curriculum/${encodeURIComponent(version)}/${encodeURIComponent(stage)}/${encodeURIComponent(subjectSegment)}`;
}
function educationLevelToStage(level) {
  switch (level) {
    case EducationLevel.PRESCHOOL:
      return "przedszkole";
    case EducationLevel.PRIMARY_1_3:
      return "klasy-1-3";
    case EducationLevel.PRIMARY_4_6:
    case EducationLevel.PRIMARY_7_8:
      return "klasy-4-8";
    case EducationLevel.SECONDARY:
      return "ponadpodstawowa";
    default:
      return null;
  }
}

// src/types/lesson/create-lesson.ts
var MAX_USER_PROMPT_LENGTH = 250;
var CreateLessonFormDTOSchema = z5.object({
  userPrompt: z5.string().min(1).max(MAX_USER_PROMPT_LENGTH),
  duration: z5.number().int().min(0).max(120),
  educationLevel: z5.number().int().min(0).max(6).transform((level) => level),
  language: z5.string(),
  grade: z5.number().int().min(1).max(8).optional(),
  // Jawny wybor wersji podstawy (opcja zaawansowana) — nieobecne/undefined = automatyczny
  // wybor (zachowanie sprzed tego pola). Patrz ScenarioGenerationSettingsDTO.curriculumVersion.
  curriculumVersion: z5.enum(CURRICULUM_VERSIONS).optional(),
  // Klient moze WYLACZYC autogeneracje slajdow/kompendium/materialow (np. gdy chce sam
  // sterowac tym, co i kiedy powstaje). Pole dziala tylko w jedna strone: `true` nadpisuje
  // ustawienie systemu, a brak pola albo `false` NIE wlacza autogeneracji tam, gdzie
  // system ja wylaczyl. Patrz AutogenService.plan.
  disable_auto_gen: z5.boolean().optional()
}).superRefine((data, ctx) => {
  if (!educationLevelForGrade(data.educationLevel, data.grade)) {
    ctx.addIssue({
      code: z5.ZodIssueCode.custom,
      message: "grade inconsistent with educationLevel",
      path: ["grade"]
    });
  }
});

// src/legal-documents.ts
var TERMS_VERSION = "2026-09-04";
var PRIVACY_VERSION = "2026-10-20";
var OAUTH_LEGAL_NOTICE_SINCE = "2026-09-03T00:00:00.000Z";

// src/item-path.ts
function getItemPath(worksheet, itemId) {
  const item = worksheet.items[itemId];
  if (!item) {
    return null;
  }
  const itemType = item.type;
  let count = 0;
  for (const id of worksheet.items_ids) {
    const currentItem = worksheet.items[id];
    if (currentItem?.type === itemType) {
      count++;
      if (id === itemId) {
        if (count > 1) {
          return `${itemType}-${count}`;
        } else {
          return itemType;
        }
      }
    }
  }
  return null;
}
function parseItemPath(path, worksheet) {
  const parts = path.split("-");
  const lastPart = parts.length > 1 ? parts[parts.length - 1] : "";
  const index = parseInt(lastPart, 10);
  let targetType;
  let targetOccurrence;
  if (!isNaN(index) && index > 0) {
    targetType = parts.slice(0, -1).join("-");
    targetOccurrence = index;
  } else {
    targetType = path;
    targetOccurrence = 1;
  }
  let count = 0;
  for (const id of worksheet.items_ids) {
    const currentItem = worksheet.items[id];
    if (currentItem?.type === targetType) {
      count++;
      if (count === targetOccurrence) {
        return id;
      }
    }
  }
  return null;
}

// src/types/material-class-ref.ts
var BASE_REPO_ID = "base";
var PHET_REPO_ID = "phet";
function parseClassRef(classRef) {
  const [repoIdOrMaterialId, materialId] = classRef.split(".");
  if (!repoIdOrMaterialId) {
    throw new Error(`Invalid class ref: ${classRef}`);
  } else if (!materialId) {
    return { repoId: BASE_REPO_ID, materialId: repoIdOrMaterialId };
  } else if (repoIdOrMaterialId === BASE_REPO_ID || repoIdOrMaterialId === PHET_REPO_ID) {
    return { repoId: repoIdOrMaterialId, materialId };
  } else {
    throw new Error(`Invalid class ref (repo): ${classRef}`);
  }
}
function formatClassRef({ repo, id }) {
  return repo === BASE_REPO_ID ? id : `${repo}.${id}`;
}

// src/curriculum-modules.ts
var MODULE_SLUGS = [
  "bezpieczenstwo-i-obrona",
  "ekonomiczno-finansowy",
  "filozoficzny",
  "klimatyczny",
  "kultura",
  "medialny"
];
var MODULE_LABELS = {
  "bezpieczenstwo-i-obrona": "bezpiecze\u0144stwo i obrona",
  "ekonomiczno-finansowy": "ekonomiczno-finansowy",
  "filozoficzny": "filozoficzny",
  "klimatyczny": "klimatyczny",
  "kultura": "kultura",
  "medialny": "medialny"
};
function isModuleSlug(value) {
  return MODULE_SLUGS.includes(value);
}
function moduleSlugFromLabel(label) {
  const found = MODULE_SLUGS.find((slug) => MODULE_LABELS[slug] === label.trim().toLowerCase());
  return found ?? null;
}
function moduleLabel(slug) {
  return MODULE_LABELS[slug];
}
function buildModulePagePath(module, stage) {
  return `/modul/${encodeURIComponent(module)}/${encodeURIComponent(stage)}`;
}
function buildModuleApiPath(module, stage) {
  return `/modules/${encodeURIComponent(module)}/${encodeURIComponent(stage)}`;
}
var MODULE_STAGES = ["klasy-1-3", "klasy-4-8"];
var MODULE_TOKEN = /\[modul-([a-z-]+)\]/g;
function moduleToken(slug) {
  return `[modul-${slug}]`;
}
function replaceModuleTokens(text, replace) {
  return text.replace(MODULE_TOKEN, (whole, slug) => isModuleSlug(slug) ? replace(slug) : whole);
}
function scanModuleTokens(text) {
  const modules = [];
  const unknown = [];
  for (const m of text.matchAll(MODULE_TOKEN)) {
    const slug = m[1];
    if (isModuleSlug(slug)) modules.push(slug);
    else unknown.push(slug);
  }
  return { modules, unknown };
}
function moduleTokensIn(text) {
  const found = new Set(scanModuleTokens(text).modules);
  return MODULE_SLUGS.filter((slug) => found.has(slug));
}
function splitModuleTokens(text) {
  const parts = [];
  let last = 0;
  for (const m of text.matchAll(MODULE_TOKEN)) {
    const slug = m[1];
    if (!isModuleSlug(slug)) continue;
    if (m.index > last) parts.push({ kind: "text", text: text.slice(last, m.index) });
    parts.push({ kind: "module", module: slug });
    last = m.index + m[0].length;
  }
  if (last < text.length) parts.push({ kind: "text", text: text.slice(last) });
  return parts;
}

// src/curriculum-labels.ts
var SUBJECT_LABELS = Object.fromEntries(
  Object.entries(SUBJECTS).map(([label, slug]) => [slug, label])
);
var STAGE_LABELS = {
  "przedszkole": "Przedszkole",
  "klasy-1-3": "Klasy 1\u20133",
  "klasy-4-8": "Klasy 4\u20138",
  "ponadpodstawowa": "Szko\u0142a ponadpodstawowa"
};
var VERSION_LABELS = {
  "2026": "Reforma 2026",
  "2017-2024": "Dotychczasowa (2017\u20132024)"
};
function subjectLabel(subject) {
  if (subject === "*") return "Wszystkie przedmioty";
  return SUBJECT_LABELS[subject] ?? subject;
}
function stageLabel(stage) {
  return STAGE_LABELS[stage];
}
function versionLabel(version) {
  return VERSION_LABELS[version] ?? version;
}

// src/curriculum-anchors.ts
function curriculumAnchorLabel(provenance) {
  const parts = [
    subjectLabel(provenance.subject),
    stageLabel(provenance.stage),
    versionLabel(provenance.version)
  ];
  if (provenance.actReference) {
    parts.push(provenance.actReference);
  }
  return parts.join(" \xB7 ");
}
function buildScenarioCurriculumAnchors(provenance, educationLevel) {
  if (!provenance) {
    const notApplicable = educationLevel !== void 0 && educationLevelToStage(educationLevel) === null;
    return { curriculum: notApplicable ? { state: "not-applicable" } : null, modules: null };
  }
  if (provenance.levelMismatch) {
    return { curriculum: { state: "level-mismatch" }, modules: null };
  }
  const curriculum = {
    state: "link",
    label: curriculumAnchorLabel(provenance),
    href: buildCurriculumPagePath(provenance.version, provenance.stage, provenance.subject)
  };
  return { curriculum, modules: buildModuleAnchors(provenance) };
}
function buildModuleAnchors(provenance) {
  if (provenance.version !== "2026") return null;
  if (!MODULE_STAGES.includes(provenance.stage)) return null;
  const modules = (provenance.modules ?? []).filter(isModuleSlug).map((slug) => ({
    slug,
    label: moduleLabel(slug),
    href: buildModulePagePath(slug, provenance.stage)
  }));
  return { state: modules.length ? "link" : "none", modules };
}
function stripCurriculumLinks(markdown) {
  const isCurriculumLink = /\[[^\]]*\]\([^)]*\/podstawa-programowa\/[^)]*\)/;
  return markdown.split("\n").filter((line) => !(isCurriculumLink.test(line) && !line.trimStart().startsWith("#"))).join("\n");
}

// src/markdown-normalize.ts
function normalizeMarkdownHeadings(markdown) {
  if (!markdown.includes("#")) return markdown;
  let inFence = false;
  return markdown.split("\n").map((line) => {
    if (/^\s*(```|~~~)/.test(line)) {
      inFence = !inFence;
      return line;
    }
    if (inFence) return line;
    return line.replace(/^(#{1,6})(?=[^#\s])/, "$1 ");
  }).join("\n");
}

// src/scenario-structure.ts
var SECTION = {
  metryczka: "metryczka",
  curriculum: "podstawa programowa",
  goals: "cele lekcji",
  priorKnowledge: "zalecana wiedza poczatkowa",
  intent: "zamysl lekcji",
  flow: "przebieg lekcji",
  notes: "uwagi/wskazowki dla nauczyciela",
  materials: "materialy",
  // starsze lekcje trzymaja pomoce pod ta nazwa
  resources: "srodki dydaktyczne"
};
function normalizeHeading(text) {
  return text.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/ł/g, "l").replace(/Ł/g, "L").toLowerCase().replace(/\s*\/\s*/g, "/").replace(/[:.]+\s*$/, "").trim();
}
function unwrapBold(line) {
  const m = line.trim().match(/^\*\*(.+)\*\*$/);
  return m ? m[1].trim() : line.trim();
}
function listItem(line) {
  const m = line.match(/^\s*(?:[-*+]|\d+[.)])\s+(.*)$/);
  return m ? m[1].trim() : null;
}
function splitH2(markdown) {
  const lines = markdown.split("\n");
  const sections = [];
  const preamble = [];
  let current = null;
  for (const line of lines) {
    const m = line.match(/^##\s+(.+?)\s*$/);
    if (m) {
      if (current) sections.push({ heading: current.heading, body: current.body.join("\n").trim() });
      current = { heading: m[1].trim(), body: [] };
      continue;
    }
    if (current) current.body.push(line);
    else preamble.push(line);
  }
  if (current) sections.push({ heading: current.heading, body: current.body.join("\n").trim() });
  return { preamble: preamble.join("\n"), sections };
}
function parseMetaRows(body) {
  const rows = [];
  for (const line of body.split("\n")) {
    const item = listItem(line) ?? line.trim();
    if (!item) continue;
    const m = item.match(/^\*\*(.+?):?\*\*\s*:?\s*(.*)$/);
    if (m && m[2].trim()) {
      rows.push({ label: m[1].trim().replace(/:$/, ""), value: m[2].trim() });
      continue;
    }
    const plain = item.match(/^([^:]{2,40}):\s+(.+)$/);
    if (plain) rows.push({ label: plain[1].trim(), value: plain[2].trim() });
  }
  return rows;
}
function splitLabelledBlocks(body) {
  const out = /* @__PURE__ */ new Map();
  const lines = body.split("\n");
  let label = null;
  let buffer = [];
  const flush = () => {
    if (label !== null) out.set(label, buffer.join("\n").trim());
    buffer = [];
  };
  for (const line of lines) {
    const heading = line.match(/^\s*#{3,6}\s+(.+?)\s*$/);
    if (heading) {
      flush();
      label = normalizeHeading(unwrapBold(heading[1]));
      continue;
    }
    const bold = line.match(/^\s*\*\*(.+?):\*\*\s*(.*)$/);
    if (bold) {
      flush();
      label = normalizeHeading(bold[1]);
      buffer = bold[2].trim() ? [bold[2].trim()] : [];
      continue;
    }
    const boldBullet = line.match(/^\s*(?:[-*+]|\d+[.)])\s+\*\*(.+?):\*\*\s*$/);
    if (boldBullet) {
      flush();
      label = normalizeHeading(boldBullet[1]);
      continue;
    }
    if (label !== null) buffer.push(line);
  }
  flush();
  return out;
}
function bulletsOf(body) {
  return body.split("\n").map(listItem).filter((x) => x !== null && x.length > 0);
}
function blockStartingWith(blocks, ...prefixes) {
  for (const [key, value] of blocks) {
    if (prefixes.some((prefix) => key.startsWith(prefix))) return value;
  }
  return null;
}
function parseGoals(body) {
  const blocks = splitLabelledBlocks(body);
  const general = blockStartingWith(blocks, "cele ogolne", "ogolne");
  const operational = blockStartingWith(blocks, "cele operacyjne", "operacyjne");
  const concepts = blockStartingWith(blocks, "pojecia kluczowe", "pojecia do opanowania", "pojecia");
  return {
    goalsGeneral: general ? bulletsOf(general) : [],
    goalsOperational: operational ? bulletsOf(operational) : [],
    keyConcepts: concepts ? concepts.replace(/\.\s*$/, "").split(/[,;]/).map((s) => s.trim()).filter(Boolean) : []
  };
}
function parseSegmentHeader(raw) {
  const trimmed = raw.trim();
  const isHeading = /^#{3,6}\s+/.test(trimmed);
  const isBold = /^\*\*.+\*\*$/.test(trimmed);
  if (!isHeading && !isBold) return null;
  const text = unwrapBold(trimmed.replace(/^#{3,6}\s+/, "")).trim().replace(/[\s*_]+$/, "");
  const named = /^segment\b/i.test(text);
  const durationMatch = text.match(/\(([^()\[\]{}]*\d[^()\[\]{}]*)[)\]}]?\s*$/);
  if (!named && !durationMatch) return null;
  let title = named ? text.replace(/^segment\s*\d*\s*[:.–—-]?\s*/i, "").trim() : text;
  let duration = null;
  if (durationMatch) {
    duration = durationMatch[1].trim();
    title = title.slice(0, title.lastIndexOf("(")).trim();
  }
  title = title.replace(/^\d+[.)]\s*/, "");
  return { title: title.replace(/[–—-]\s*$/, "").trim(), duration };
}
function parseFlow(body) {
  const segments = [];
  let current = null;
  for (const line of body.split("\n")) {
    const header = parseSegmentHeader(line);
    if (header) {
      if (current) segments.push(current);
      current = { title: header.title, duration: header.duration, bullets: [], meta: [] };
      continue;
    }
    if (!current) continue;
    const bullet = listItem(line);
    if (bullet) {
      current.bullets.push(bullet);
      continue;
    }
    const meta = line.match(/^\s*\*\*(.+?):\*\*\s*(.+)$/);
    if (meta) current.meta.push({ label: meta[1].trim(), value: meta[2].trim() });
  }
  if (current) segments.push(current);
  return segments;
}
function parseMaterials(body) {
  const blocks = splitLabelledBlocks(body);
  const lessonBlock = blockStartingWith(blocks, "materialy superlekcji");
  const lessonMaterials = lessonBlock ? bulletsOf(lessonBlock) : [];
  const taken = new Set(lessonMaterials);
  return {
    lessonMaterials,
    // Sam punkt-etykieta („- **Sprzet:**") wprowadza podliste, a nie jest pozycja
    // do przygotowania — na liscie pomocy bylby pusta linijka.
    equipment: bulletsOf(body).filter((item) => !taken.has(item) && !/^\*\*.+:\*\*$/.test(item))
  };
}
function emptyStructure() {
  return {
    title: null,
    meta: [],
    curriculum: null,
    goalsGeneral: [],
    goalsOperational: [],
    keyConcepts: [],
    priorKnowledge: [],
    intent: [],
    segments: [],
    notes: null,
    lessonMaterials: [],
    equipment: [],
    extra: []
  };
}
function parseScenarioStructure(markdown) {
  const source = normalizeMarkdownHeadings(markdown ?? "");
  const empty = { ...emptyStructure(), ok: false, fallback: source };
  if (!source.trim()) return empty;
  const { preamble, sections } = splitH2(source);
  const titleMatch = preamble.match(/^#\s+(.+?)\s*$/m);
  const result = {
    ...emptyStructure(),
    ok: false,
    fallback: source,
    title: titleMatch ? titleMatch[1].trim() : null
  };
  for (const section of sections) {
    const key = normalizeHeading(section.heading);
    switch (key) {
      case SECTION.metryczka:
        result.meta = parseMetaRows(section.body);
        break;
      case SECTION.curriculum:
        result.curriculum = section.body || null;
        break;
      case SECTION.goals:
        Object.assign(result, parseGoals(section.body));
        break;
      case SECTION.priorKnowledge:
        result.priorKnowledge = bulletsOf(section.body);
        break;
      case SECTION.intent:
        result.intent = section.body.split(/\n{2,}/).map((p) => p.trim()).filter(Boolean);
        break;
      case SECTION.flow:
        result.segments = parseFlow(section.body);
        break;
      case SECTION.notes:
        result.notes = section.body || null;
        break;
      case SECTION.materials:
      case SECTION.resources:
        Object.assign(result, parseMaterials(section.body));
        break;
      default:
        result.extra.push({ heading: section.heading, body: section.body });
    }
  }
  result.ok = result.segments.length > 0 || result.goalsGeneral.length > 0 || result.goalsOperational.length > 0;
  return result;
}
var MATERIAL_LINK = /\]\(\/materials\/([^)\s]+)\)/g;
function collectMaterialReferences(structure) {
  const seen = /* @__PURE__ */ new Set();
  const refs = [];
  structure.segments.forEach((segment, index) => {
    const text = [...segment.bullets, ...segment.meta.map((m) => m.value)].join("\n");
    for (const match of text.matchAll(MATERIAL_LINK)) {
      const materialId = match[1];
      if (seen.has(materialId)) continue;
      seen.add(materialId);
      refs.push({ materialId, segmentNumber: index + 1, segmentTitle: segment.title });
    }
  });
  return refs;
}

// src/types/survey.ts
import { z as z6 } from "zod";
var SURVEY_BONUS_CREDITS = 30;
var LESSONS_USED_OPTIONS = ["0", "1", "2-3", "4+"];
var TIME_SAVED_OPTIONS = ["none", "lt30", "30-60", "gt60"];
var CURRENT_METHOD_OPTIONS = ["self", "chatgpt", "publisher", "other-tool"];
var COMPARISON_OPTIONS = ["worse", "similar", "better", "much-better"];
var PRICE_MONTHLY_OPTIONS = ["0", "10", "20", "30", "50+"];
var SURVEY_MISSING_MAX_LENGTH = 2e3;
var creditsSurveyAnswersSchema = z6.object({
  lessonsUsed: z6.enum(LESSONS_USED_OPTIONS),
  timeSaved: z6.enum(TIME_SAVED_OPTIONS),
  currentMethod: z6.enum(CURRENT_METHOD_OPTIONS),
  comparison: z6.enum(COMPARISON_OPTIONS),
  priceMonthly: z6.enum(PRICE_MONTHLY_OPTIONS),
  missing: z6.string().trim().max(SURVEY_MISSING_MAX_LENGTH).optional(),
  interviewOk: z6.boolean()
}).strict();
var LESSON_VERDICT_OPTIONS = ["yes", "with-fixes", "no"];
var LESSON_VERDICT_COMMENT_MAX_LENGTH = 1e3;
var lessonVerdictSchema = z6.object({
  verdict: z6.enum(LESSON_VERDICT_OPTIONS),
  comment: z6.string().trim().max(LESSON_VERDICT_COMMENT_MAX_LENGTH).optional()
}).strict();
export {
  AUTO_LABEL,
  AUTO_VALUE,
  AvailableModels,
  BASE_REPO_ID,
  COMPARISON_OPTIONS,
  CURRENT_METHOD_OPTIONS,
  CURRICULUM_STAGES,
  CURRICULUM_VERSIONS,
  CreateLessonFormDTOSchema,
  ELEMENT_POOL_EXHAUSTED,
  EducationLevel,
  GenerateScenarioFormDTOSchema,
  GenerateWorksheetItemParams,
  GetWorksheetItemParams,
  INSTRUCTION_MAX_LENGTH,
  INSUFFICIENT_CREDITS,
  INVITED_CREDITS,
  INVITER_BONUS_CREDITS,
  LESSONS_USED_OPTIONS,
  LESSON_ELEMENT_POOL,
  LESSON_PRICE,
  LESSON_VERDICT_COMMENT_MAX_LENGTH,
  LESSON_VERDICT_OPTIONS,
  MAX_USER_PROMPT_LENGTH,
  MODULE_LABELS,
  MODULE_SLUGS,
  MODULE_STAGES,
  ModifyKnowledgeFormDTOSchema,
  OAUTH_LEGAL_NOTICE_SINCE,
  PHET_REPO_ID,
  PLANS,
  PRICE_MONTHLY_OPTIONS,
  PRIVACY_VERSION,
  REJECT_REASONS,
  SCENARIO_DURATION_OPTIONS,
  SLIDE_LAYOUTS,
  STARTING_CREDITS,
  SUBJECTS,
  SUBJECT_DESCRIPTIONS,
  SUBJECT_DESCRIPTIONS_TIMELESS,
  SURVEY_BONUS_CREDITS,
  SURVEY_MISSING_MAX_LENGTH,
  TERMS_VERSION,
  THINKING_EFFORTS,
  TIME_SAVED_OPTIONS,
  acquisitionSourceSchema,
  buildCurriculumApiPath,
  buildCurriculumPagePath,
  buildModuleApiPath,
  buildModulePagePath,
  buildScenarioCurriculumAnchors,
  collectMaterialReferences,
  creditsSurveyAnswersSchema,
  curriculumAnchorLabel,
  curriculumPageSubjectFromSegment,
  curriculumPageSubjectToSegment,
  educationLevelForGrade,
  educationLevelToStage,
  formatClassRef,
  getAllSubjects,
  getEducationLevelDescription,
  getEducationLevelDescriptionLong,
  getEducationLevelDescriptionWithoutAge,
  getGradeDescription,
  getItemPath,
  getLanguagePolishName,
  getModelDisplayName,
  getSubjectsWithDescriptions,
  instructionSchema,
  isArtifactStale,
  isModuleSlug,
  isValidModel,
  isWordsearchEnabled,
  languages,
  lessonVerdictSchema,
  moduleLabel,
  moduleSlugFromLabel,
  moduleToken,
  moduleTokensIn,
  normalizeMarkdownHeadings,
  parseClassRef,
  parseItemPath,
  parseModel,
  parseModelString,
  parseScenarioStructure,
  primaryEducationLevelForGrade,
  replaceModuleTokens,
  scanModuleTokens,
  splitModuleTokens,
  stageLabel,
  stripCurriculumLinks,
  subjectLabel,
  usesLatinScript,
  versionLabel
};
